import React, { Component } from 'react';
import { connect } from "react-redux";
import Cookies from 'js-cookie'
import { Link } from "react-router-dom";
import Backbtn from './elements/Backbtn'
import { Footer, Nav, Loader, Analytics } from './elements'

import { promotionFetch } from '../redux/actions'

class Promotion extends Component {

    constructor() {
        super()
        this.state = {
            isLogin: false,
            user: ""
        }
    }

    componentWillMount() {
        if(Cookies.get('user')){
            this.setState({
                isLogin: true,
                user: JSON.parse(Cookies.get('user'))
            })
        } else {
            window.location = "/login"
        }
        this.props.promotionFetch()
    }

    showPromotions() {
        if(this.props.promotions) {
            return this.props.promotions.map((item, index) => {
                return (
                    <div className="each-promotion" key={++index}>
                        <Analytics />
                        <Link to={{ pathname: "/promotiondetail", search: "?id="+item.id+"&title="+item.title+"&photo="+item.photo}}>
                            <div className="promo-img">
                                <img src={item.thumbnail} alt="โปรโมชั่นแอร์"/>
                            </div>
                            <h3 className="promo-title">{item.title}</h3>
                            <p className="promo-detail">{item.sub_desc}</p>
                        </Link>
                    </div>
                )
            })
        } else {
            return <Loader />
        }
    }

    render() { 
        if(!this.state.isLogin) return <div></div>
        return ( 
            <div className="page-promotion">
                <div className="promotion-header">
                    <Backbtn />
                    <div className="title">
                        <p>โปรโมชั่น</p>
                    </div>
                    <Nav />
                </div>
                <div className="promotion-list container">
                    {this.showPromotions()}
                </div>
                <Footer />
            </div>
        )
    }
}
 
const mapStateToProps = ({ promotion }) => {
    return { 
        promotions: promotion.promotions
    }
}
 
export default connect(mapStateToProps, { 
    promotionFetch
})(Promotion)